import type React from 'react';

import { Box, FormField, Label, ToggleButton, ToggleButtonGroup } from '@zillow/constellation-10';

import { SNOW_REMOVAL } from '../../../../constants';

type Props = {
  setButtonGroupClick: (fieldName: string, buttonValue: string) => void;
  areaName?: string;
  fieldName: string;
  buttonValue: string;
  twoButtonArea?: boolean;
};

export default function AreaButtonGroup_v2({
  setButtonGroupClick,
  areaName,
  fieldName,
  buttonValue,
  twoButtonArea,
}: Props): JSX.Element {
  function onButtonClick(event: React.MouseEvent<HTMLButtonElement>): void {
    const value = event.currentTarget.dataset.value || '';
    setButtonGroupClick(fieldName, value);
  }

  return (
    <Box css={{ marginBottom: 'layout.tight' }}>
      <FormField
        required
        label={<Label>{twoButtonArea ? 'Who will be responsible for this area?' : areaName}</Label>}
        control={
          <ToggleButtonGroup conjoined aria-label="snow removal responsibility" css={{ width: '100%' }}>
            <ToggleButton
              selected={buttonValue === SNOW_REMOVAL.LANDLORD}
              data-value={SNOW_REMOVAL.LANDLORD}
              data-test="AreaButtonGroup-landlord"
              onClick={onButtonClick}
            >
              Landlord
            </ToggleButton>
            <ToggleButton
              selected={buttonValue === SNOW_REMOVAL.TENANT}
              data-value={SNOW_REMOVAL.TENANT}
              onClick={onButtonClick}
            >
              Tenant
            </ToggleButton>
            {!twoButtonArea && (
              <ToggleButton
                selected={buttonValue === SNOW_REMOVAL.NA}
                data-value={SNOW_REMOVAL.NA}
                onClick={onButtonClick}
              >
                N/A
              </ToggleButton>
            )}
          </ToggleButtonGroup>
        }
      />
    </Box>
  );
}
